import * as React from 'react';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import { Theme, AlertColor, useTheme } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Logout from '@mui/icons-material/Logout';
import { abreviarIniciaisNome } from '../../common/utils/funcoes';
import { novoLogin, useLogin } from '../../contexts/LoginContext';
import { apiServer } from '../../api';
import { useNavigate } from 'react-router-dom';
import ChangePasswordModal from './AlterarSenha';
import PasswordIcon from '@mui/icons-material/Password';
import AlertSnackbar from '../AlertaUsuario';
import { sha256 } from '../../common/utils/funcoes';

export default function AccountMenu() {
    const [isModalOpenPassword, setModalOpenPassword] = React.useState<boolean>(false);
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [tipoAlerta, setTipoAlerta] = React.useState<AlertColor>('error');
    const open = Boolean(anchorEl);
    const theme: Theme = useTheme();
    const [login, setLogin] = useLogin();
    const navigate = useNavigate();

    const [alertOpen, setAlertOpen] = React.useState<boolean>(false);
    const [alertMessage, setAlertMessage] = React.useState<string>('');

    const handleCloseAlert = () => setAlertOpen(false);

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const showAlert = (tipoAlerta: AlertColor, message: string) => {
        setAlertOpen(false);
        setTipoAlerta(tipoAlerta);
        setAlertMessage(message);
        setAlertOpen(true);
    }

    const handleClose = () => {
        setAnchorEl(null);

        apiServer<string>().post("/token/finalizar-sessao", "", {})
            .then(() => {
                setLogin(novoLogin());
                navigate("/login");
            }).catch((response) => {
                console.log(response);
            });
    };

    const handleChangePassword = async (currentPassword: string, newPassword: string) => {
        const senhaSha256 = await sha256(currentPassword);

        if (senhaSha256 !== login.usuario?.senha) {
            showAlert('error', 'A senha atual está incorreta.');
            return;
        }

        apiServer<string>().post("/usuario/alterar-senha",
            login.accessToken,
            {
                senhaAtual: senhaSha256,
                novaSenha: await sha256(newPassword),
                email: login.usuario?.email
            })
            .then(() => {
                if (login.usuario)
                    login.usuario.senha = senhaSha256;

                handleCloseAlert();
                showAlert('success', 'Senha alterada com sucesso');
            }).catch((response) => {
                showAlert('error', response);
            });
    };

    const handleCloseModalPassword = () => setModalOpenPassword(false);

    const handleOpenChangePassword = () => {
        setModalOpenPassword(true);
        setAnchorEl(null);
    };

    return (
        <React.Fragment>
            <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
                <Tooltip title={login?.usuario?.nome}>
                    <IconButton
                        onClick={handleClick}
                        size="small"
                        sx={{ ml: 2 }}
                        aria-controls={open ? 'account-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                    >
                        <Avatar sx={{ backgroundColor: "white", color: theme.palette.primary.main }}>
                            {abreviarIniciaisNome(login?.usuario?.nome)}
                        </Avatar>
                    </IconButton>
                </Tooltip>
            </Box>
            <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                PaperProps={{
                    elevation: 0,
                    sx: {
                        overflow: 'visible',
                        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                        mt: 1.5,
                        '& .MuiAvatar-root': {
                            width: 32,
                            height: 32,
                            ml: -0.5,
                            mr: 1,
                        },
                        '&:before': {
                            content: '""',
                            display: 'block',
                            position: 'absolute',
                            top: 0,
                            right: 14,
                            width: 10,
                            height: 10,
                            bgcolor: 'background.paper',
                            transform: 'translateY(-50%) rotate(45deg)',
                            zIndex: 0,
                        },
                    },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
                <MenuItem onClick={handleOpenChangePassword}>
                    <ListItemIcon>
                        <PasswordIcon fontSize="small" />
                    </ListItemIcon>
                    Alterar senha
                </MenuItem>

                <MenuItem onClick={handleClose}>
                    <ListItemIcon>
                        <Logout fontSize="small" />
                    </ListItemIcon>
                    Sair
                </MenuItem>
            </Menu>

            <ChangePasswordModal
                open={isModalOpenPassword}
                handleClose={handleCloseModalPassword}
                handleChangePassword={handleChangePassword}
            />

            <AlertSnackbar
                open={alertOpen}
                onClose={handleCloseAlert}
                message={alertMessage}
                severity={tipoAlerta} // Define como erro, mas você pode personalizar
            />

        </React.Fragment>
    );
}
